/*global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import sortBy from 'lodash/sortBy';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { createSelector } from 'reselect';

// import { ModalActions } from '../../actions/modal';
import { ElementActions } from '../../actions/element';
import { validateAndDispatch } from '../../helpers/form';
import SingleSelectBox from '../inputs/SingleSelectBox';
// import FieldError from '../form/FieldError';
import InputField from '../form/InputField';
import '../../styles/CreateElementModal.css';

const rootElementSelector = (state, props) => {
  const rootElement = state.projects.get('rootElementId');
  return rootElement ? rootElement : null;
};

const currentProjectIdSelector = (state, props) => {
  const projectId = state.projects.get('currentProjectId');
  return projectId ? projectId : null;
};

const elementTypesSelector = (state, props) => {
  const elementTypes = state.elementTypes.get('elementTypes');
  return elementTypes ? elementTypes : null;
};

const createElementModalSelector = state => {
  const selector = formValueSelector('createElement');
  return selector(
    state,
    'elementName',
    'elementType',
    'parentElement',
    'bulkAdd',
  );
};

const CreateElementModalSelector = createSelector(
  [
    rootElementSelector,
    currentProjectIdSelector,
    elementTypesSelector,
    createElementModalSelector,
  ],
  (rootElement, currentProjectId, elementTypes, createElementModal) => ({
    rootElement,
    currentProjectId,
    elementTypes,
    fields: createElementModal,
    initialValues: {
      bulkAdd: true,
    },
  }),
);

@connect(CreateElementModalSelector)
@reduxForm({
  form: 'createElement',
  destroyOnUnmount: false,
  enableReinitialize: false,
})
export default class CreateElementModal extends Component {
  static propTypes = {
    currentProjectId: PropTypes.string,
    elementTypes: PropTypes.instanceOf(Map).isRequired,
  };

  buildElementTypesList() {
    const { elementTypes } = this.props;
    const elementTypesArray = [];

    const filteredTypes = elementTypes.filter(x => x.get('type') !== 'System');

    filteredTypes.forEach(v => {
      elementTypesArray.push({ label: v.get('type'), value: v.get('id') });
    });

    return sortBy(elementTypesArray, 'label');
  }

  submit = (values, dispatch) => {
    console.log('values', values);
    const { currentProjectId, reset, rootElement, elementTypes } = this.props;

    const props = {};

    if (values.elementType && values.elementType.value) {
      elementTypes
        .getIn([values.elementType.value, 'props'])
        .filter((o, k) => {
          const defaultValue = o.getIn(['_default']);
          return (
            k.startsWith('_') === false &&
            typeof defaultValue !== 'undefined' &&
            (defaultValue && defaultValue !== '')
          );
        })
        .map(p => p.getIn(['_default']))
        .forEach((v, k) => {
          props[k] = v;
        });
    }

    const createElementFormObject = {
      name: values.elementName || null,
      type_id:
        values.elementType && values.elementType.value
          ? values.elementType.value
          : null,
      parent_id: values.parentElement
        ? values.parentElement.get('id')
        : rootElement,
      project_id: currentProjectId,
      props,
    };

    const validation = {
      elementName: [{ rule: 'required', label: 'element name' }],
      elementType: [{ rule: 'required', label: 'element type' }],
    };

    // throw new SubmissionError({ elementName: 'name is required' });

    console.log('name', values.elementName);
    return validateAndDispatch(
      dispatch,
      ElementActions.createElement(currentProjectId, createElementFormObject),
      validation,
      values,
    ).then(() => {
      reset();
    });
  };

  render() {
    const {
      fields: { elementType },
      handleSubmit,
      submitting,
    } = this.props;

    const elementTypesList = this.buildElementTypesList();

    const elementNameField = (
      <fieldset className="form-group">
        <Field
          name="elementName"
          type="textarea"
          component={InputField}
          label="Element Name(s)"
          rows="5"
          className="form-control"
          placeholder="One element per line..."
          style={{ marginBottom: 10 }}
        />
      </fieldset>
    );

    return (
      <div className="fs-modal-content">
        <h4>Create New Element</h4>
        <form>
          <div className="modal-form-wrapper">
            {elementNameField}
            <Field
              name="elementType"
              component={SingleSelectBox}
              options={elementTypesList}
              label={'Element Type'}
              placeholder={'Select Element Type'}
              value={elementType}
              field={'elementType'}
              formName={'createElement'}
              small={'Select an Element Type.'}
            />
          </div>
          <div className="modal-form-button-wrapper">
            <button
              className="btn btn-primary modal-button-full"
              onClick={handleSubmit(this.submit)}
              disabled={submitting}
            >
              {submitting && (
                <i className="fa fa-cog fa-spinner fa-spin" />
              )}{' '}
              Create New Element
            </button>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/CreateElementModal.js